'use client';

import Filters from './Filters';
import Overview from './charts/overview/Overview';
import DailySales from './charts/daily-sales/DailySales';
import TopItems from './charts/top-items/TopItems';
import TopAddons from './charts/top-addons/TopAddons';
import Orders from './charts/orders/Orders';
import { SalesSummaryProvider } from './SalesSummaryContext';
import { Text } from '@instamenu/ui-system-next';
import { useLocale } from '@instamenu/context-i18n';

export default function SalesSummary() {
  const { i18n } = useLocale();
  return (
    <SalesSummaryProvider>
      <Text variant="h1">{i18n.t('salesSummary.salesSummary')}</Text>
      <Filters />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
        <Overview />
        <DailySales />
        <Orders />
        <TopItems />
        <TopAddons />
      </div>
    </SalesSummaryProvider>
  );
}
